<!--
 * @Description:
 * @Author: mdb
 * @Date: 2023-04-13 13:53:26
 * @LastEditTime: 2023-04-20 10:44:20
 * @LastEditors: mdb
-->
<template>
  <TemplateManage subdomain="lbu" :permission="permission" />
</template>

<script setup lang="ts">
import TemplateManage from '@/views/marketing/marketingManage/templateManage/index.vue'

const permission = {
  add: 'lbu_tpl_add_btn',
  del: 'lbu_tpl_del_btn',
  edit: 'lbu_tpl_edit_btn'
}
</script>
<script lang="ts">
export default { name: 'DcCosLbuTemplateManage' }
</script>

<style scoped></style>
